import Modal from "components/layout/modal";
import { FunctionComponent } from "react";
import { Admin } from "models/admin";
import { showGenericError, showGenericSuccess } from "lib/notification";
import AccessForm from "./access-form";
import {
  adminDoPatchAdmin,
  adminDoPatchAdminDisable,
  adminDoPatchAdminEnable,
} from "services/admin/admin";

interface AccessModalProps {
  admin: Admin;
  onUpdate: () => Promise<void>;
  onClose: () => Promise<void>;
}

const AccessModal: FunctionComponent<AccessModalProps> = ({
  admin,
  onUpdate,
  onClose,
}) => {
  const onSubmit = async (values: any) => {
    const { access } = values;

    try {
      if (access === "NOTHING") {
        // disable
        await adminDoPatchAdminDisable(admin);
      } else {
        // enable
        await adminDoPatchAdminEnable(admin);
        await adminDoPatchAdmin(admin.uuid, {
          org_admin: access === "ORG_ADMIN",
        });
      }

      showGenericSuccess();
    } catch (err) {
      showGenericError();
    }

    // signal and close
    onUpdate();
    onClose();
  };

  return (
    <Modal title="Vaihda pääsyoikeustasoa">
      <AccessForm admin={admin} onSubmit={onSubmit} onClose={onClose} />
    </Modal>
  );
};

export default AccessModal;
